import { useContext, useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { GlobalContext } from '../../context/Context';
import Select from "react-select";

const AssignVanModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, vanId, selectedEmp }) => {
  let { state } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const [selectedEmployees , setSelectedEmployees] = useState([])

  useEffect(() => {
    let allSelectedEmp = selectedEmp.map((eachEmp, i) => { return {label: eachEmp?.name, value: eachEmp?.employee_id}})
    // console.log("allSelectedEmp", allSelectedEmp)
    setSelectedEmployees(allSelectedEmp)
  } , [selectedEmp])

  const assignEmp = async() => {

    let selectedId = [];

    for(let i=0; i < selectedEmployees?.length; i++){
      selectedId.push(selectedEmployees[i].value)
    }

    console.log(vanId);
    console.log(selectedId)

    let data = {
      "fleet_van_id" : vanId,
      "assigned_employees" : selectedId
    }

    try {
      let apiRes = await apiCall({ method: "post", url: "assign-unassigned-van-to-user", data: data })
      onSubmit(apiRes?.message || `Employee Assigned`);
    } catch (error) {
      console.log("Error", error)
      onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
    }
  }

  return (
    <form onSubmit={(e) => {e.preventDefault(); assignEmp()}}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head} !bg-white !block`}>
          <div className="flex items-center justify-between">
            <h4> Assign Van </h4>
            <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Employee</label>
                  <Select
                    isMulti
                    placeholder={` -- Select Employee -- `}
                    value={
                      selectedEmployees
                    }
                    onChange={(selected) => {
                      console.log("selected", selected)
                      setSelectedEmployees(selected)
                    }}
                    options={state?.getDropdowns?.activeEmployeeList?.map((ele) => ({label: ele?.emp_name, value: ele?.emp_id}))}
                    className="w-full h-12"
                    components={{
                      IndicatorSeparator: () => null, // 🚀 removes separator
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        height: "48px",
                        minHeight: "48px",
                        borderRadius: "0.375rem", // rounded-md
                        borderColor: "#d1d5db", // blue-500 or gray-300
                        boxShadow: "none", // focus:ring-2 ring-blue-500
                        "&:hover": {
                          borderColor: "#9ca3af", // gray-400
                        },
                        fontSize: "14px", // text-xs
                        paddingLeft: "0.5rem", // px-2
                        paddingRight: "0.5rem",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "48px",
                        padding: "0 0.25rem",
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: "0px 0px 20px",
                        width: "14px",
                        height: "14px",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#374151", // text-gray-700
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#9ca3af", // text-gray-400
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "0.375rem",
                        border: "1px solid #e5e7eb", // gray-200
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        zIndex: 50,
                      }),
                      indicatorContainer: (base) => ({
                        ...base,
                        padding: '0px'
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        padding: "0.5rem 0.75rem",
                        cursor: "pointer",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                            ? "#f3f4f6"
                            : "white",
                        color: state.isSelected ? "white" : "#374151", // text-gray-700
                      }),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default AssignVanModal